export const decryptId = (encryptedId) => {
    const encryptedIdArray = encryptedId.split('/');
    return parseInt(encryptedIdArray[encryptedIdArray.length - 1]);
};
